function view (path) {
  return () => import(/* webpackChunkName: '' */ '@/views/som/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const SOMRoutes = [
  {
    path: '/som/dashboard',
    component: view('Dashboard'),
    name: 'som.dashboard',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Dashboard',
          active: true
        }
      ]
    }
  }
]

export default SOMRoutes
